import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeSlideVariants, staggerListVariants } from '../ui/Motion.js';
import { PenTool, BookOpen, BookMarked } from 'lucide-react';

const staggerContainer = staggerListVariants;

const staggerItem = fadeSlideVariants;

const quickActions = [
  { icon: <PenTool className="h-5 w-5" />, label: 'Nuevo visual', to: '/canvas' },
  { icon: <BookOpen className="h-5 w-5" />, label: 'Nuevo curso', to: '/courses/new' },
  { icon: <BookMarked className="h-5 w-5" />, label: 'Registrar lectura', to: '/progress' },
];

export function QuickActions() {
  return (
    <div>
      <h2 className="mb-4 text-sm font-semibold text-[var(--color-text)] uppercase tracking-wider">
        Acciones rápidas
      </h2>
      <motion.div
        className="grid grid-cols-2 gap-3 sm:grid-cols-3"
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
      >
        {quickActions.map((a) => (
          <motion.div key={a.to} variants={staggerItem}>
            <Link
              to={a.to}
              className="flex items-center gap-3 rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-4 transition-all hover:border-xd-action hover:shadow-sm"
            >
              <div className="rounded-lg bg-xd-action/10 p-2 text-xd-action">{a.icon}</div>
              <span className="text-sm font-medium text-[var(--color-text)]">{a.label}</span>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
